import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendDownloadFileAPI } from '@/services/BackendAPI.js';

export default {
  createPDF(data = {}) {
    const format = data.format ? data.format : 'merge';
    return BackendDownloadFileAPI('post', ApiRoutes.testPreparationPrint.createPDF(format), data);
  },
};
